module.exports = __webpack_public_path__ + "img/horizontal.aa34633d.svg";